import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useIsAdmin } from '@/lib/auth'

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const isAdmin = useIsAdmin()
  const navigate = useNavigate()
  useEffect(() => {
    if (!isAdmin) navigate({ to: '/tickets' as never })
  }, [isAdmin, navigate])
  if (!isAdmin) return null
  return <>{children}</>
}
